import { pageTypes } from 'config/pageTypes';

import heroImage from 'assets/images/sgp/SGPHero/medium-self-storage-hero.webp';

import relatedContentImage1 from 'assets/images/sgp/featuredContentImages/mediumSizeRelatedContentImage1.webp';
import relatedContentImage2 from 'assets/images/sgp/featuredContentImages/mediumSizeRelatedContentImage2.webp';
import relatedContentImage3 from 'assets/images/sgp/featuredContentImages/mediumSizeRelatedContentImage3.webp';
import relatedContentImage4 from 'assets/images/sgp/featuredContentImages/mediumSizeRelatedContentImage4.webp';

import storage5x15 from 'assets/images/sgp/SizeGuide/5x15.svg';
import storage10x10 from 'assets/images/sgp/SizeGuide/10x10.svg';
import storage10x15 from 'assets/images/sgp/SizeGuide/10x15.svg';

import howToUseImage from 'assets/images/sgp/MediumStorage/MediumSizeSelfStorageUseCases.webp';
import { linkToOtherPSPsBlock } from './shared';

const heroContent = {
	title: 'Find Affordable Medium Self Storage Units Near You',
	description:
		'Medium self storage units hit the sweet spot for many storage users, especially those storing belongings for their families or entire households. Medium self storage units can help you get things done without the clutter or chaos. [Renting a mid-sized unit for everything from moves and relocations](https://www.selfstorage.com/blog/pre-move-checklist/) to spring cleaning gives you the space you need at the right price.',
	image: heroImage,
	storageType: 'Medium Self Storage',
	subheading: 'Find Budget Friendly Medium Self Storage',
	CTAtext: 'Find Storage',
	searchPlaceholder: 'Enter ZIP Code or City Name',
};

const videoContent = {
	title: 'Medium Self Storage Video',
	background: 'blueWhiteGradient',
	pageType: pageTypes.SGP,
	modules: [
		{
			type: 'video',
			props: {
				pageType: pageTypes.SGP,
				content: {
					subtitle: 'Sizing Up Your Options',
					title: 'What Are Medium Self Storage Units?',
					description:
						"Medium self storage units include 5x15, 10x10, and 10x15 spaces that cover 75 to 150 square feet. Think of a medium-sized self storage unit as offering a small spare bedroom's worth of space, all the way up to a spacious one-car garage's worth of extra space. It's the perfect amount of space, without pricey long term overhead or unused potential.",
					videoSrc:
						'https://www.youtube.com/embed/_lqEgh2Ow80?rel=0&playsinline=1&enablejsapi=1',
				},
			},
		},
	],
};

const sizeChartContent = [
	{
		type: 'cardStrip',
		props: {
			heading: 'Medium Self Storage Unit Size Guide',
			pageType: pageTypes.SGP,
			description:
				"Not sure which size fits your situation? Here's a quick breakdown of what each medium self storage unit can hold:",
			cardData: [
				{
					title: '5x15',
					size: '75 ft² | 600 ft³',
					content:
						'**Best For:**\n\n- Contents of a [one-bedroom apartment](https://www.selfstorage.com/blog/studio-vs-one-bedroom-apartment/)\n- Large furniture pieces like sofas, dressers, and bed frames\n- [Bicycles and sporting equipment](https://www.selfstorage.com/storage-types/bike-self-storage)\n- Office supplies and business inventory',
					imageSrc: storage5x15,
					contentAlign: 'text-left sgp',
				},
				{
					title: '10x10',
					size: '100 ft² | 800 ft³',
					content:
						'**Best For:**\n\n- Contents of a two-bedroom apartment\n- Full living room and dining room furniture sets\n- Large appliances\n- Moving overflow and in-between-homes storage',
					imageSrc: storage10x10,
					contentAlign: 'text-left sgp',
				},
				{
					title: '10x15',
					size: '150 ft² | 1,200 ft³',
					content:
						'**Best For:**\n\n- Contents of a two- to three-bedroom home\n- Full furniture sets\n- Large appliances, lawn equipment, and vehicle parts\n- Home renovation overflow and contractor supply storage',
					imageSrc: storage10x15,
					contentAlign: 'text-left sgp',
				},
			],
		},
	},
];

const pricingContent = [
	{
		type: 'sizeComparisonSection',
		props: {
			content: {
				title: 'Medium Self Storage Unit Pricing Overview',
				description:
					'Affordable medium self storage is easier to find than you might expect.\n\nSelfStorage.com reviewed average pricing data from 2026 to give you an accurate pricing snapshot so you can plan ahead and reserve self storage with confidence.\n\nKeep in mind that [prices can shift based on your location](https://www.selfstorage.com/blog/storage-unit-prices/), available amenities, and seasonal demand, so it always pays to shop and compare using our self storage comparison tool.',
				image: '',
				contentdec: '',
			},
			storageData: [
				{
					size: '5x15',
					heading: "5' Wide x 15' Long",
					desc: [
						'**Monthly Average:** $65.13 (2026)\n\n**Unit + Climate Control:** Expect a 10-20% increase in monthly cost',
					],
				},
				{
					size: '10x10',
					heading: "10' Wide x 10' Long",
					desc: [
						'**Monthly Average:** $77.06 (2026)\n\n**Unit + Climate Control:** Expect a 10-20% increase in monthly cost',
					],
				},
				{
					size: '10x15',
					heading: "10' Wide x 15' Long",
					desc: [
						'**Monthly Average:** $106.02 (2026)\n\n**Unit + Climate Control:** Expect a 10-20% increase in monthly cost',
					],
				},
			],
		},
	},
];

const reviewsContent = {
	headerTitle: '',
	reviews: [
		{
			id: 'medium-self-storage-review-1',
			title: 'We wanted to rent a medium sized…',
			stars: 5,
			text: "We wanted to rent a medium sized storage that had a controlled environment so if the weather is to cool or to hot it's got the right temperature. It was also very easy to hold it then go rent it. I can say I appreciate it all.",
			customerName: 'Brenda Allbritton',
			date: '2022-09-02',
			link: 'https://www.trustpilot.com/reviews/63124cac7f7a8621ee50f6b5',
		},
		{
			id: 'medium-self-storage-review-2',
			title: 'Easiest booking experience',
			stars: 5,
			text: 'This company had the best pricing for a medium sized unit that I could find online. Upon booking, I immediately received a call from their Office following up on what I need to bring and other fees upon move in. I was very satisfied with the Customer Service I received.',
			customerName: 'M. Ottinger',
			date: '2018-07-06',
			link: 'https://www.trustpilot.com/reviews/5b3f973f6d33bc0e8415ff4e',
		},
		{
			id: 'medium-self-storage-review-3',
			title: 'It was super easy',
			stars: 5,
			text: 'It was super easy to see what amenities were offered, as well as reserve a unit. They also had medium sized options available which seems to be rare.',
			customerName: 'Jenny',
			date: '2018-07-04',
			link: 'https://www.trustpilot.com/reviews/5b3c53666d33bc0b0885d1ce',
		},
		{
			id: 'medium-self-storage-review-4',
			title: 'Great service',
			stars: 5,
			text: 'The process of renting a unit and setting everything up was seamless. They even gave me a call to let me know what to expect on my initial visit. I would recommend this storage facility to everyone. Great service.',
			customerName: 'K. Smillie',
			date: '2026-01-17',
			link: 'https://www.trustpilot.com/reviews/696bb6e4f15e27023dbbff3a',
		},
	],
};

const faqSectionContent = {
	header: 'Frequently Asked Questions',
	description: '',
	image: storage10x15,
	faqs: [
		{
			question: 'How big is a medium self storage unit?',
			answer: "Medium self storage units are roughly the size of a standard bedroom. That gives you 75-150 square feet of floor space and plenty of vertical room to stack. It's one of the most popular sizes available because it strikes a practical balance: enough space to handle a real move or big life change without paying for more than you need.",
		},
		{
			question: 'What fits in a 10x10 storage unit?',
			answer: 'A 10x10 unit can comfortably hold the contents of a one-bedroom apartment, including furniture. If you pack smart, that means a bedroom set, living room furniture, and some moving boxes. Its versatility makes it a popular choice for home renovations, temporary relocations, or anyone consolidating two households.',
		},
		{
			question:
				'Is a 10x10 storage unit big enough for a two-bedroom apartment?',
			answer: "It can work for a lightly furnished two-bedroom, but it'll require thoughtful packing and some vertical stacking. If you have a lot of large furniture pieces, you might want to consider sizing up to a large self storage unit. When in doubt, it helps to list out your larger items before committing to a size.",
		},
		{
			question: 'Can you fit a car in a 10x10 storage unit?',
			answer: "Car self storage requires more space than what a 10x10 can give you, as a 10x10 unit won't have enough depth to hold most mid-size sedans. For car self storage, you'd want to look at larger unit sizes, typically 10x20 or above.",
		},
		{
			question: 'How much does a 10x10 storage unit cost?',
			answer: "Pricing depends on your location, the facility, and add-ons like climate control or extended access hours. Medium units sit in the middle of the pricing range; more than a locker or mini unit, but typically more affordable than larger sizes. It's worth shopping around a few facilities in your area, especially if you're flexible on location or move-in timing, as there are often deals and discounts available.",
		},
	],
};

const relatedContent = {
	heading: 'Related Resources',
	type: 'unitCards',
	id: 'medium-storage-related-content',
	data: {
		slug: 'medium-storage-related-content',
		unitCards: [
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/self-storage-unit-size-guide-2/',
				layout: false,
				plain: true,
				date: '',
				image: relatedContentImage1,
				content:
					'Self Storage Size Guide: Finding the Perfect Storage Unit Size',
			},
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/storage-unit-prices/',
				layout: false,
				plain: true,
				date: 'June 18, 2024',
				image: relatedContentImage2,
				content: 'Storage Unit Prices: How Much Is a Storage Unit?',
			},
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/self-storage-improves-garage-shed-organization/',
				layout: false,
				plain: true,
				date: '',
				image: relatedContentImage3,
				content:
					'5 Ways Self Storage Improves Storage Shed & Garage Organization',
			},
			{
				title: 'Storage',
				url: 'https://www.selfstorage.com/blog/how-storage-reduces-cost-of-living/',
				layout: false,
				plain: true,
				date: '',
				image: relatedContentImage4,
				content:
					'The Benefits of Downsizing Your Home: How to Reduce the Cost of Living with Self Storage',
			},
		],
	},
};

export const MediumSelfStorageContent = {
	type: 'medium-self-storage',
	pageType: pageTypes.SGP,
	reviews: reviewsContent.reviews,
	sections: [
		{
			title: 'Medium Self Storage Hero',
			background: 'default',
			pageType: pageTypes.SGP,
			modules: [
				{
					type: 'hero',
					id: 'medium-self-storage-hero',
					props: {
						content: heroContent,
						pageType: pageTypes.SGP,
						additionalProps: {
							heading: {
								size: 'large',
								color: 'white',
								weight: 'ultraBold',
							},
						},
					},
				},
			],
		},
		videoContent,
		{
			title: 'Medium Self Storage Size Chart',
			noPaddingTop: true,
			modules: sizeChartContent,
		},
		{
			title: 'Medium Self Storage Pricing',
			pageType: pageTypes.SGP,
			noPadding: true,
			modules: pricingContent,
		},
		{
			title: 'How to Use Medium Self Storage',
			pageType: pageTypes.SGP,
			background: 'blueGradient',
			modules: [
				{
					type: 'video',
					props: {
						content: {
							title: 'How Many Ways Can I Use a Medium Self Storage Unit?',
							imageSrc: howToUseImage,
							description:
								'Medium self storage includes some of the most popular self storage unit sizes available, and for good reason. These units are practical enough for everyday use, and spacious enough to handle large life transitions. \n\nThink bigger than renting medium self storage to get your belongings out of sight, out of mind. Self storage can become a valuable partner in improving quality of life and giving yourself room to breathe, no matter what life throws your way.',
						},
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			noPaddingTop: true,
			pageType: pageTypes.SGP,
			modules: [
				{
					type: 'reviews',
					title: 'Reviews Section',
					slug: 'medium-self-storage-reviews',
					props: {
						pageType: pageTypes.SGP,
						reviewsData: reviewsContent,
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						content: faqSectionContent,
					},
				},
			],
		},
		{
			title: 'Related Content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: relatedContent,
					},
				},
			],
		},
		linkToOtherPSPsBlock,
		{
			title: 'Storage Near You',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'StorageSize',
					},
				},
			],
		},
	],
};
